import { useState } from "react";
import { emitirNotaCredito } from "../services/facturaService";

export const useEmitirNotaCredito = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = async (datos, envasado) => {
    try {
      setLoading(true);
      setError(null);

      console.log("DATOS ND: ", datos);
      console.log("ENVASADO ND: ", envasado);

      const res = await emitirNotaCredito(datos, envasado);
      return res;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    execute,
    loading,
    error,
  };
};
